<script setup>

import Table from "@/components/common/other/Table";
import {inject} from 'vue';

const shipments = inject("shipments");

</script>

<template>

  <div class="cmp-collection-delivery">
    <Table
        :key="shipments.viewShipment.collectionAndDelivery.length"
        height="160"
        :selectable="false"
        :row-selection="false"
        :allow-grid-menu="false"
        :allowPagination="false"
        :columns="shipments.collectionDelivery.gridColumns"
        :dataSource="shipments.viewShipment.collectionAndDelivery">
    </Table>
  </div>
</template>

<style scoped>

.cmp-collection-delivery {
  height: 160px;
}
</style>
